import React, { useEffect, useState, useRef } from "react";
import styles from "../OurBussiness/Overview.module.scss";
import classNames from "classnames";
import BreadCrumb from "../CommonComponents/BreadCrumb.tsx";
import businessOverviewBannerImg from "../../assets/images/business-overviewBannerImg.png";
import individualTrainigImg from "../../assets/images/individualTrainigImg.png";
import EnterPriseImg from "../../assets/images/EnterPriseImg.png";
import globalTrainingImg from "../../assets/images/globalTrainingImg.png";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import MetaComponent from "../CommonComponents/MetaComponent.tsx";

const Overview: React.FC = () => {
  const breadcrumb = [
    { title: "Home", link: "/" },
    { title: "Our Businesses", link: "/our-businesses" },
    { title: "Overview", link: "/overview-business" },
  ];

  return (
    <div className={styles.OverviewBusinessPage}>
      <MetaComponent
        title="Vocational Training Programs, Corporate Training Solutions & Career Oriented Training Centres | Aptech Limited"
        desc="Aptech Limited offers comprehensive vocational programs, customized corporate training solutions, and career-oriented training centres to build future-ready professionals."
        keywords="vocational training, skill training, enterprise business, institutional business, Aptech limited"
      />
      <BreadCrumb menu={breadcrumb} />
      <motion.div
        initial={{ opacity: 0, y: 100 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1, ease: "easeInOut" }}
      >
        <Banner />
      </motion.div>
      <IndividualTraining />
    </div>
  );
};

export default Overview;

const Banner: React.FC = () => {
  const [isTablet, setIsTablet] = useState(window.innerWidth < 992);

  useEffect(() => {
    const handleResize = () => setIsTablet(window.innerWidth < 992);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return (
    <div className="container">
      {!isTablet ? (
        <div className={`${styles.Banner} section mt-5`}>
          <div className="row">
            <div
              className={`${styles.box} col-lg-7 col-md-12 col-sm-12 col-xs-12`}
            >
              <p className="heading">our businesses</p>
              <p className={`${styles.desc} para`}>
                At Aptech, we are dedicated to transforming careers of students
                and professionals through{" "}
                <a href="/our-businesses/domestic-retail">
                  industry-relevant training programs
                </a>
                . With a strong global presence, we cater to students,
                professionals, and enterprises, equipping them with the skills
                necessary to thrive in today's dynamic job market. Our
                businesses span across key verticals, offering modern-day
                learning solutions across diverse industries.
              </p>
            </div>
            <div
              className={`${styles.BusinessBannerTwoCont} col-lg-5 col-md-12 col-sm-12 col-xs-12 d-flex`}
            >
              <img
                src={"/images/young-trainer-addressing-students.png"}
                alt="Young Trainer Leading A Classroom Discussion"
                title="Training Session Focused On Student Interaction"
                className={classNames(styles.BusinessBannerTwo, "img-fluid")}
              />
            </div>
          </div>
        </div>
      ) : (
        <div className={`${styles.Banner} section mt-5`}>
          <div className="row">
            <div
              className={`${styles.box} col-lg-7 col-md-12 col-sm-12 col-xs-12`}
            >
              <p className="heading">our businesses</p>
              <p className={`${styles.desc} para`}>
                At Aptech, we are dedicated to transforming careers of students
                and professionals through industry-relevant training programs.
                With a strong global presence, we cater to students,
                professionals, and enterprises, equipping them with the skills
                necessary to thrive in today's dynamic job market. Our
                businesses span across key verticals, offering modern-day
                learning solutions across diverse industries.
              </p>
            </div>
            <div
              className={`${styles.BusinessBannerTwoCont} col-lg-5 col-md-12 d-flex`}
            >
              <img
                src={"/images/young-trainer-addressing-students.png"}
                alt="Young Trainer Leading A Classroom Discussion"
                title="Training Session Focused On Student Interaction"
                className={`${styles.BusinessBannerOne} img-fluid col-md-6`}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const IndividualTraining: React.FC = () => {
  interface DataItem {
    src: string;
    imgAlt: string;
    imgTitle: string;
    title: string;
    description: string;
    paragraph?: string;
    redirectTo: string;
  }
  const data: DataItem[] = [
    {
      src: "/images/young-executive-working-with-documents.png",
      imgAlt: "Young Professional In Formal Attire Checking Clipboard",
      imgTitle: "Confident Team Member Reviewing Key Documents",
      title: "Domestic Retail",
      description: `
          <p class="mb-2"><a href="/">Aptech</a> offers a wide-range of career and skill development programs across its diverse training verticals, equipping students with in-demand skills tailored to specific industries like:</p>
          <ul style="list-style: none; padding-left: 0;">
            <li style="font-weight: bold;">Beauty and Wellness</li>
            <li style="font-weight: bold;">Animation, VFX, and Gaming</li>
            <li style="font-weight: bold;">Virtual Production</li>
            <li style="font-weight: bold;">Aviation, Hospitality, and Luxury Retail</li>
            <li style="font-weight: bold;">Information Technology</li>
            <li style="font-weight: bold;">Banking and Finance</li>
            <li style="font-weight: bold;">Preschool Education</li>
            <li style="font-weight: bold;">ProAlley</li>

          </ul>
        `,
      paragraph:
        "Through these specialised verticals and a strong focus on career growth opportunities, Aptech ensures that students across all its centres receive industry-relevant training, enhancing their employability and professional growth. By integrating global business solutions, Aptech addresses diverse learning needs, bridging skill gaps and fostering professional growth worldwide.",
      redirectTo: "/our-businesses/domestic-retail",
    },
    {
      src: "/images/business-team-collaborating-at-cafe.png",
      imgAlt: "Business Team Working Together On A Project At A Café Table",
      imgTitle: "Team Collaboration In A Modern Work Environment",
      title: "Institutional Business (EBG)",
      description: `
            <p class="mb-2">The Institutional Business (EBG) of Aptech focuses on providing corporate and institutional clients with customized training and assessment solutions. The team works with leading government and private organisations and educational institutions to enhance workforce skills and assess their talent through:</p>
            <ul style="list-style: none; padding-left: 0;">
              <li style="font-weight: bold;">Aptech Training Solutions</li>
              <li style="font-weight: bold;">Aptech Assessment & Testing Solutions</li>
              <li style="font-weight: bold;">Education Institutes and Corporates (EIC) Unit</li>
            </ul>
          `,
      paragraph: `With years of expertise in global business solutions, <strong>The Institutional Business (EBG)</strong> group of Aptech empowers organizations with world-class training and assessment solutions, driving workforce excellence, professional growth and business development across sectors.`,
      redirectTo: "/our-businesses/institutional-business",
    },
    {
      src: "/images/businessman-holding-digital-earth.png",
      imgAlt: "Businessperson Holding Digital Earth With Global Tech Overlay",
      imgTitle: "Empowering The World With Digital Solutions",
      title: "International Retail",
      description: `
            <p class="mb-2">Aptech is a leader in vocational and career-oriented training, with 740+ learning centres located in 200+ cities worldwide. Aptech has partnered with various universities and educational institutions to make international education accessible to students. With over 40+ years of experience, Aptech has established a significant global presence across various countries, including Vietnam, Egypt, Qatar, Kenya, Malaysia, UAE, Saudi Arabia, and Nigeria. Through its commitment to quality training and skill-based education, the International Retail wing of Aptech continues to empower individuals, enabling them to excel in the competitive global landscape.</p>
          
          `,
      paragraph: "",
      redirectTo: "/our-businesses/international-retail",
    },
  ];
  const navigate = useNavigate();

  const sectionRefs = useRef<(HTMLElement | null)[]>([]);
  const [hasAnimated, setHasAnimated] = useState<boolean[]>(
    data.map(() => false),
  );
  useEffect(() => {
    const observers = sectionRefs.current.map((ref, index) => {
      if (!ref) return null;

      const observer = new IntersectionObserver(
        ([entry]) => {
          // Only animate if scrolling down and it hasn't animated before
          if (entry.isIntersecting && !hasAnimated[index]) {
            setHasAnimated((prev) => {
              const updated = [...prev];
              updated[index] = true;
              return updated;
            });
          }
        },
        { threshold: 0.2, rootMargin: "0px 0px -50px 0px" }, // Ensures it's triggered when scrolling down
      );

      observer.observe(ref);
      return observer;
    });

    return () => {
      observers.forEach((observer) => observer?.disconnect());
    };
  }, [hasAnimated]);

  return (
    <div className="container">
      <div className={`${styles.IndividualTraining} section`}>
        <div className={styles.EBGData}>
          {data.map((item, index) => {
            return (
              <motion.div
                key={index}
                ref={(el) => (sectionRefs.current[index] = el)}
                initial={{ opacity: 0, y: 100 }}
                animate={hasAnimated[index] ? { opacity: 1, y: 0 } : {}}
                transition={{
                  duration: 1,
                  ease: "easeInOut",
                  delay: index * 0.1,
                }}
                className={`row g-0 justify-content-center ${styles.EbgCardRow}`}
              >
                {/* Image Section */}
                <div className={`col-lg-3 col-md-12 ${styles.EBGImgDiv}`}>
                  <img
                    src={item.src}
                    alt={item.imgAlt}
                    title={item.imgTitle}
                    className={`${styles.logoImage} img-fluid`}
                  />
                </div>

                {/* Content Section */}
                <div className="col-lg-9 col-md-12">
                  <div
                    className={`d-flex flex-column justify-content-end align-items-start ${styles.EbgDataContent}`}
                  >
                    <h6
                      className={`${styles.contentTitle} caps subHeading mb-2`}
                    >
                      {item.title}
                    </h6>
                    <p
                      className={`${styles.contentDescription} para`}
                      dangerouslySetInnerHTML={{ __html: item.description }}
                    ></p>
                    {item.paragraph && (
                      <p
                        className={`${styles.contentDescription} para`}
                        dangerouslySetInnerHTML={{ __html: item.paragraph }}
                      ></p>
                    )}
                    <button
                      className={`secondary-btn para ${styles.buttonStyle}`}
                      onClick={() => navigate(item.redirectTo)}
                    >
                      Know More
                    </button>
                  </div>
                </div>

                {/* Paragraph + Button */}
                {/* <div className="col-12">
                  {item.paragraph && (
                    <p
                      className={`${styles.contentDescription} para`}
                      dangerouslySetInnerHTML={{ __html: item.paragraph }}
                    ></p>
                  )}
                  <button
                    className={`secondary-btn para ${styles.buttonStyle}`}
                    onClick={() => navigate(item.redirectTo)}
                  >
                    Know More
                  </button>
                </div> */}
              </motion.div>
            );
          })}
        </div>
      </div>
    </div>
  );
};
